import Text from '../../components/Text';
import Button from '../../components/Button';
import ViewItems from '../../components/ViewItems';
import ThankYouFunctional from './index.function';
import AuthWrapper from '../../components/AuthWrapper';
import images from '../../constants/images';
import { cn } from '../../utils/utils';
import { fontSizes } from '../../constants/constants';

const ThankYou = () => {
  const { TextWeight, getContentKey, isArabic ,navigate} =
    ThankYouFunctional();

  return (
    <AuthWrapper>
      <ViewItems className={`w-full`}>
        <img
          src={images.textLogo}
          width={70}
          className={cn(isArabic ? 'self-end' : 'self-start')}
        />
        <Text
          text={getContentKey('heading')}
          weight={TextWeight.semiBold}
          size={fontSizes.h18}
          className={'mb-5 mt-10'}
        />
        <Button
          text={getContentKey('proceed_btn')}
          className={'mt-6 my-2 w-full'}
          onClick={() => {
            navigate('/');
          }}
          type={'button'}
        />
      </ViewItems>
    </AuthWrapper>
  );
};

export default ThankYou;
